import { manufacturingFetch } from "@/lib/manufacturingClient";
import type { ServiceEventLineItem, ServiceEventLineItemCategory } from "./types";

type OrgEnvelope = { ok: true; organization_id: string };

export function listServiceEventLineItems(eventId: string) {
  const q = new URLSearchParams({ event_id: eventId });
  return manufacturingFetch<
    OrgEnvelope & { lines: ServiceEventLineItem[]; subtotal_cents: number }
  >(`/api/service/event-line-items?${q.toString()}`, { method: "GET" });
}

export function upsertServiceEventLineItem(payload: {
  id?: string;
  event_id: string;
  category: ServiceEventLineItemCategory;
  label: string;
  quantity?: number;
  unit_cents?: number | null;
  amount_cents?: number | null;
  sort_order?: number;
  delete?: boolean;
}) {
  return manufacturingFetch<
    OrgEnvelope & { line?: ServiceEventLineItem; deleted?: boolean }
  >("/api/service/event-line-items/upsert", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
}
